import Vue from 'vue'

const FLASK_ENDPOINT = `${process.env.VUE_APP_FLASK_URL}/api`

export default {
  verifyEmail (params) {
    return Vue.prototype.$httpSilentError.post(`${FLASK_ENDPOINT}/emails/verify`, params).then(response => response.data)
  },

  findEmail (params) {
    return Vue.prototype.$httpSilentError.post(`${FLASK_ENDPOINT}/emails/find`, params).then(response => response.data)
  },

  findEmailBySlug (params) {
    return Vue.prototype.$httpSilentError.post(`${FLASK_ENDPOINT}/emails/find_by_slug`, params).then(response => response.data)
  }
}
